module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-585.732679e.woff2";